import { AloftDate, AloftPrice } from '@aloft/toolkit-shared';

export const SIMILAR_COMPARABLE_PRIOR_SALE_THRESHOLD_MONTHS = 12;
export const SIMILAR_COMPARABLE_PRIOR_SALE_THRESHOLD_PRICE_DIFF = 0.3;

export type SimilarComparablePriorSaleRelationship = 'higher' | 'lower';

export const getSimilarComparableToSubjectPriorSaleRelationship = (
  compSaleDate: AloftDate,
  compSalePrice: AloftPrice,
  priorSaleDate: AloftDate,
  priorSalePrice: AloftPrice,
): SimilarComparablePriorSaleRelationship | undefined => {
  const differenceInMonths = Math.abs(priorSaleDate.differenceInCalendarMonths(compSaleDate));
  if (differenceInMonths > SIMILAR_COMPARABLE_PRIOR_SALE_THRESHOLD_MONTHS) return undefined;

  const priceDifference = compSalePrice.sub(priorSalePrice).abs();
  if (priceDifference.ratio(priorSalePrice) <= SIMILAR_COMPARABLE_PRIOR_SALE_THRESHOLD_PRICE_DIFF) {
    return undefined;
  }

  return compSalePrice.gt(priorSalePrice) ? 'higher' : 'lower';
};

export const getSimilarComparableToSubjectPriorSaleTooltip = (
  compSaleDate: AloftDate | undefined,
  compSalePrice: AloftPrice | undefined,
  priorSaleDate: AloftDate | undefined,
  priorSalePrice: AloftPrice | undefined,
): string | undefined => {
  if (!compSaleDate || !compSalePrice || !priorSaleDate || !priorSalePrice) return undefined;

  const relationship = getSimilarComparableToSubjectPriorSaleRelationship(
    compSaleDate,
    compSalePrice,
    priorSaleDate,
    priorSalePrice,
  );
  if (!relationship) return undefined;

  return relationship === 'higher'
    ? "Sold within 1 year of Subject’s prior sale, for more than 30% of Subject’s prior sale price."
    : "Sold within 1 year of Subject’s prior sale, for less than 30% of Subject’s prior sale price.";
};
